<template>
  <div class="home">
    <Topbar />
    <section class="content">
      <el-tabs :value="activeName"
               tab-position="left"
               class="left"
               @tab-click="handleClick">
        <el-tab-pane v-for="list in leftList"
                     :key="list.name"
                     :label="list.label"
                     :name="list.name">
        </el-tab-pane>
      </el-tabs>

      <div class="right">
        <div class="right-content">
          <router-view></router-view>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import { leftList } from '@utils/sideList'
import Topbar from './topbar'
export default {
  name: 'Home',
  data() {
    return {
      activeName: '',
      leftList
    }
  },
  methods: {
    handleClick(tab) {
      if (tab.name !== this.activeName) {
        this.$router.push(`/${tab.name}`)
      }
    }
  },
  watch: {
    $route(newV, oldV) {
      if (newV.path !== oldV.path) {
        this.activeName = newV.path.split(/[\/?]/)[1]
      }
    }
  },
  created() {
    this.activeName = this.$route.path.split(/[\/?]/)[1]
  },
  components: {
    Topbar
  }
}
</script>

<style lang="less" scoped>
.home {
  .content {
    height: calc(~"100vh - 60px");
    padding-top: 2px;
    overflow: hidden;
    display: flex;
    background-color: #f6f6f6;

    .left {
      flex: 0 0 auto;
      // background: #f7f8fa;
      /deep/.el-tabs__header.is-left {
        margin-right: 1px;
      }
    }
    .right {
      flex: 1 1 auto;
      overflow: auto;
      .right-content {
        margin: 20px;
        padding: 10px 20px;
        background: #fff;
        border-radius: 6px;
        .content-title {
          text-align: left;
          line-height: 50px;
          font-weight: 600;
          margin-bottom: 10px;
          width: 120px;
          border-bottom: 1px solid #fef0f0;
        }
      }
    }
  }
  /deep/ .el-tabs__nav-wrap {
    .el-tabs__item {
      padding: 0 40px;
      line-height: 48px;
      height: 48px;
      text-align: left;
      &.is-active {
        background: #e1edfa;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue